var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.8577 27c1.3187-1.1145 2.1423-2.3961 2.1423-3 0-1.1942-3.1946-5-7.06226-5-1.04915 0-2.04498.2867-2.93774.7273v-11.50545c0-2.13432 1.11303-3.22185 3.3185-3.22185h4.911v7.5316c0 1.3134.6541 1.9392 2.0239 1.9392h7.7466v9.3175c0 2.1344-1.1028 3.2117-3.3185 3.2117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.2843 13.0652h7.589c-.0651-.4207-.3767-.8311-.8904-1.3338l-5.8973-5.75647c-.5-.49254-.9417-.79035-1.3904-.86226v7.39853c0 .3694.1918.554.5891.554z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 24.0025c0 .546-.4528.9975-.9984.9975-.55035 0-1.0016-.4515-1.0016-.9975 0-.551.45125-1.0025 1.0016-1.0025.5456 0 .9984.4515.9984 1.0025z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.93774 29c3.87386 0 7.06226-3.8118 7.06226-5 0-1.1942-3.1946-5-7.06226-5-3.82281 0-6.93774 3.8058-6.93774 5 0 1.1882 3.11493 5 6.93774 5zm.06726-1.875c1.736 0 3.1768-1.411 3.1768-3.1173 0-1.7217-1.4408-3.1327-3.1768-3.1327-1.75101 0-3.18682 1.411-3.18682 3.1327 0 1.7063 1.43581 3.1173 3.18682 3.1173z",
    fillRule: "evenodd",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePreview);
export default __webpack_public_path__ + "static/media/File_Preview.8cc4cda730f5827306380713bb299c4a.svg";
export { ForwardRef as ReactComponent };